import Box from '@mui/material/Box';
import CircularProgress, {
  type CircularProgressProps,
} from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import type { PaletteProps } from '@mui/system/palette';

interface Props {
  value: number;
  label?: string | number;
  labelSize?: string | number;
  size?: string | number;
  progressColor?: PaletteProps['color'];
}

const RelativeBox = styled(Box)({
  position: 'relative',
  display: 'inline-flex',
});
const AbsoluteBox = styled(Box)({
  top: '-7%',
  left: '-4%',
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CircularProgressWithLabel = ({
  value,
  label,
  labelSize,
  size,
  progressColor,
  ...rest
}: Props & Omit<CircularProgressProps, 'value' | 'size' | 'color'>) => (
  <RelativeBox sx={{ fontSize: labelSize || 'inherit' }}>
    <CircularProgress
      variant="determinate"
      value={value}
      {...rest}
      size={size}
      sx={{ mb: 1, color: progressColor }}
    />
    <AbsoluteBox>{label || `${value}%`}</AbsoluteBox>
  </RelativeBox>
);

export default CircularProgressWithLabel;
